import './OnboardingErrorView.scss';

import { useSalesforceSync } from '@hooks';

import { Button, Row, Space } from 'antd';
import { EMAILS, ONBOARDING_ERROR_COPY, URLS } from '@sonar-software/sonar-ts-constants';
import { GatewayCard, GatewayContent } from '../../general';
import React, { useCallback } from 'react';

export interface OnboardingErrorViewProps {
	onRestart: () => void;
}

export const OnboardingErrorView: React.FC<OnboardingErrorViewProps> = ({ onRestart }) => {
	const { resetSync } = useSalesforceSync();

	const handleRestart = useCallback(() => {
		resetSync();
		onRestart();
	}, [ onRestart, resetSync ]);

	return (
		<GatewayContent>
			<GatewayCard
				className='onboarding-error-view'
				title={ ONBOARDING_ERROR_COPY.SOMETHING_WENT_WRONG }>
				<p>
					{ ONBOARDING_ERROR_COPY.PARTIAL_HAVING_ISSUES }
					<a
						href={ URLS.SUPPORT_EMAIL }
						rel='noopener'
						target='_blank'>
						{ EMAILS.SUPPORT }
					</a>
					{ ONBOARDING_ERROR_COPY.PARTIAL_QUESTIONS }
				</p>
				<br />
				<br />
				<Row justify='center'>
					<Space size={ 24 }>
						<Button
							id='restart-onboarding-button'
							onClick={ handleRestart }
							size='large'
							type='primary'>
							{ ONBOARDING_ERROR_COPY.RESTART_ONBOARIDNG }
						</Button>
					</Space>
				</Row>
			</GatewayCard>
		</GatewayContent>
	);
};
